module.exports = __webpack_public_path__ + "img/1f696.8072d6b.svg";